var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuLoginDetails = function SvgMenuLoginDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Menu-LoginDetails_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Menu-LoginDetails_svg__st1{fill:#666}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M837.2 51.8c-1-.1-1.8-.6-2.8-.6H421.6c-63.5 0-115.2 51.7-115.2 115.2v38.4c0 21.2 17.2 38.4 38.4 38.4s38.4-17.2 38.4-38.4v-38.4c0-21.2 17.2-38.4 38.4-38.4h178.9l-11.7 3.9c-31.1 10.8-52 40.1-52 72.9v576H421.6c-21.2 0-38.4-17.2-38.4-38.4v-76.8c0-21.2-17.2-38.4-38.4-38.4s-38.4 17.2-38.4 38.4v76.8c0 63.5 51.7 115.2 115.2 115.2h115.2V896c0 42.4 34.4 76.8 76.8 76.8 8.2 0 16-1.2 24.5-3.8l230.7-76.9c31.1-10.8 52-40 52-72.9V128c0-44.8-38.6-79.9-83.6-76.2z",
    className: "Menu-LoginDetails_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410.3 408 256.7 254.5c-11-11-27.5-14.3-41.9-8.3-14.3 5.9-23.7 20-23.7 35.5v115.2H37.6c-21.2 0-38.4 17.2-38.4 38.4s17.2 38.4 38.4 38.4h153.6v115.2c0 15.5 9.4 29.5 23.7 35.5 14.4 5.9 30.9 2.7 41.9-8.3l153.6-153.6c15-15.2 15-39.4-.1-54.5z",
    className: "Menu-LoginDetails_svg__st1"
  })));
};
export default SvgMenuLoginDetails;